<template>
    <Content id="section-purchases">
        <LoadingApp :is_full_page="true" :isLoading="isLoading" />

        <primary-title>
            Meus {{ isBudgetLayout ? "orçamentos" : "pedidos" }}
        </primary-title>

        <card-account >
            <template v-if="purchases.length">
                <div
                    v-for="purchase in purchases"
                    :key="purchase.id"
                    class="card-body"
                >
                    <div class="col-6" style="margin:auto">
                        <div>
                            <p style="text-transform: capitalize; font-size: 15px; margin-left: -30px;"
                                v-html="purchase.status_pedido">
                            </p>
                        </div>
                        <div>
                            <strong>
                                Nº {{ purchase.id }}
                            </strong>
                        </div>
                        <div v-if="isShoppingPortal" style="margin: 12px 0 0 0">
                            <p style="text-transform: capitalize; font-size: 16px">
                                Fornecedor: {{purchase.supplier_name}}
                            </p>
                        </div>
                    </div>
                    <div class="col-6" style="text-align: end; margin:auto">
                        <div>
                            <strong style="color:#666; font-size: 12px;">
                                Data:
                                {{ purchaseCreatedAt(purchase.created_at) }}
                            </strong>
                        </div>
                        <div >
                            <strong style="font-size: 22px;">
                                {{ currency.money(purchase.total_amount) }}
                                <template v-if="showIpi && purchase.show_ipi && !calculateIpi">
                                    + IPI
                                </template>
                            </strong>
                        </div>
                        <div>
                            <a
                                :href="`${$baseUrl}my-account/purchases/${purchase.id}`"
                                title="Ver pedido detalhado"
                            >
                                <button style="padding: 5px 10px;">
                                    Ver detalhes
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </template>
        </card-account>

        <Pagination
            :source="pagination"
            @navigate="navigate"
            :pagination_range="6"
        />
    </Content>
</template>

<script>
import { CPrimaryTitle } from "../../../components/Styles/Components/styled";
import { swall } from "../../../services/sweetAlert";
import { mapActions, mapGetters, mapState } from "vuex";
import { Content } from "./style";
import Currency from "../../../helpers/parseCurrency";
import Pagination from "../../../components/Pagination.vue";
import LoadingApp from "../../../components/LoadingApp.vue";
import { CCardAccount } from "../../../components/Styles/Template/styled";

export default {
    name: "Purchases",
    components: {
        Pagination,
        LoadingApp,
        Content,
        "primary-title": CPrimaryTitle,
        "card-account": CCardAccount
    },
    data() {
        return {
            isLoading: false,
            page: 1,
            currency: Currency
        };
    },
    created() {
        this.getList();
    },
    methods: {
        ...mapActions("purchases", [
            "getPurchases",
            "setPurchases",
            "setPagination"
        ]),
        navigate(page = this.page) {
            this.page = page;
            this.getList();
            let titlePurchases = document.querySelector("#section-purchases");
            let sectionPurchases = titlePurchases.getBoundingClientRect();
            window.scroll(
                0,
                sectionPurchases.top + scrollY - titlePurchases.offsetHeight
            );
        },
        getList() {
            this.isLoading = true;
            let filters = this.getFilters();

            this.getPurchases(filters)
                .then(response => {
                    this.isLoading = false;
                    this.setPurchases(response.data.data);
                    this.setPagination(response.data);
                })
                .catch(error => {
                    this.isLoading = false;
                    swall(error?.msg ?? error?.message ?? error);
                });
        },
        getFilters() {
            return {
                page: this.page
            };
        },
        updateList() {
            this.getList();
        },
        purchaseCreatedAt(created_at) {
            return created_at
                .split("T")[0]
                .split("-")
                .reverse()
                .join("/");
        }
    },
    computed: {
        ...mapState("purchases", ["purchases", "pagination"]),
        ...mapGetters("company", ["showIpi"]),
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false;
        },
        calculateIpi() {
            return this.$root.$children[0].$attrs.company?.settings?.calculate_ipi ?? false
        },
        isShoppingPortal(){
            return this.$root.$children[0].$attrs.company?.settings?.activate_shopping_portal ?? false
        },
    }
};
</script>
